import { Navigate } from "react-router-dom";

import { useAuth } from "../contexts/AuthContext";
import { isAuthTransitionInProgress } from "../utils/impersonation";

const AdminRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading || isAuthTransitionInProgress()) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <i className="fas fa-spinner fa-spin text-4xl text-primary-600 mb-4" />
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  if (user?.role !== "admin") {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default AdminRoute;
